import { render } from "./AI.vue?vue&type=template&id=4c1a5d81&scoped=true"
import script from "./AI.vue?vue&type=script&lang=js"
export * from "./AI.vue?vue&type=script&lang=js"

import "@/assets/css/layout_ai.css?vue&type=style&index=0&id=4c1a5d81&scoped=true&lang=css"
import "@/assets/css/components/commonPopup.css?vue&type=style&index=1&id=4c1a5d81&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1a5d81"]])

export default __exports__